export default __webpack_public_path__ + "static/media/rank.73366f38.svg";